import { 
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogTitle, 
    Divider, 
    Slider, 
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { getGamePreference, postGamePreference } from "../api";
import { StyledCircularProgress } from "../StyledComponents";
import { GamePreference } from "../types/GamePreference";
import { useTranslation } from "react-i18next";

const StyledPreferenceRow = styled.div`
    padding: 10px;
`

const StyledDialogContent = styled(DialogContent)`
    min-height: 50px;
    position: relative;
`
export interface GamePreferenceDialogProp {
    open: boolean,
    onClose: (submitted?: boolean) => void,
    userId: string,
}

export default function GamePreferenceDialog(props: GamePreferenceDialogProp) {

  const {t} = useTranslation()

  //undefined is default state, null = no record found in db.
  const [gamePreference, setGamePreference] = useState<GamePreference | null>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { onClose, open, userId } = props;

  useEffect(() => {
    setGamePreference(undefined)
    setIsLoading(true);
    getGamePreference(userId).then(data => {
      setIsLoading(false);
      console.log(data);
      setGamePreference(data !== null? data : null);
    })
  }, [userId]);

  function handleClose() { onClose(); }

  const saveButtonClicked = () => {
    console.log("saved");
    if (userId !== undefined && gamePreference !== undefined && gamePreference !== null) {
      setIsLoading(true);
      console.log(gamePreference);
      postGamePreference(userId, gamePreference).then(() => {
        onClose(true);
        setIsLoading(false);
      });
    }
  }

  const sliderOnChange = (preference: string, value: number | number[]) => {
    if (gamePreference !== undefined && gamePreference !== null) {
      setGamePreference({ ...gamePreference, [preference]: value });
    }
  }

  const discardWaitingTimeMarks = [
    {
      value: 3,
      label: 3,
    },
    {
      value: 5,
      label: 5,
    },
    {
      value: 7,
      label: 7,
    },
    {
      value: 9,
      label: 9,
    },
    {
      value: 11,
      label: 11,
    },
  ]

  const booleanMarks = [
    {
      value: 0,
      label: t("gamePreferenceDialog.no"),
    },
    {
      value: 1,
      label: t("gamePreferenceDialog.yes"),
    },
  ];

  const dragToDiscardMarks = [
    {
      value: 0,
      label: t("gamePreferenceDialog.click"),
    },
    {
      value: 1,
      label: t("gamePreferenceDialog.drag"),
    }
  ]

  function booleanValueLabelFormat(value: number) {
    let mark = booleanMarks.find(mark => mark.value === value);
    return (mark !== undefined)? mark.label : "";
  }

  function dragToDiscardLabelFormat(value: number) {
    let mark = dragToDiscardMarks.find(mark => mark.value === value);
    return (mark !== undefined)? mark.label : "";
  }

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth maxWidth="sm">
      <DialogTitle id="simple-dialog-title">{t("gamePreferenceDialog.title")}</DialogTitle>
      <StyledDialogContent>
        {isLoading ? <StyledCircularProgress /> : null}
        {gamePreference === null && <div style={{ textAlign: "center" }}>{t("gamePreferenceDialog.haventPlayed")}</div>}
        {gamePreference !== undefined && gamePreference !== null &&
          <div>
            <StyledPreferenceRow>
              <Typography id="discrete-slider-restrict" gutterBottom>
                {t("gamePreferenceDialog.gameHints")}
              </Typography>
              <Slider
                value={gamePreference.show_hints? gamePreference.show_hints : 0}
                valueLabelDisplay="auto"
                valueLabelFormat={booleanValueLabelFormat}
                step={1}
                marks={booleanMarks}
                min={0}
                max={1}
                onChange={(event, value) => sliderOnChange("show_hints", value)}
              />
            </StyledPreferenceRow>
            <Divider />
            <StyledPreferenceRow>
              <Typography id="discrete-slider-restrict" gutterBottom>
                {t("gamePreferenceDialog.chowPongKong")}
              </Typography>
              <Slider
                value={gamePreference.action_auto_show? gamePreference.action_auto_show : 0}
                valueLabelDisplay="auto"
                valueLabelFormat={booleanValueLabelFormat}
                step={1}
                marks={booleanMarks}
                min={0}
                max={1}
                onChange={(event, value) => sliderOnChange("action_auto_show", value)}
              />
            </StyledPreferenceRow>
            <Divider />
            <StyledPreferenceRow>
              <Typography id="discrete-slider-restrict" gutterBottom>
                {t("gamePreferenceDialog.autoArrangement")}
              </Typography>
              <Slider
                value={gamePreference.tiles_auto_sort? gamePreference.tiles_auto_sort : 0}
                valueLabelDisplay="auto"
                valueLabelFormat={booleanValueLabelFormat}
                step={1}
                marks={booleanMarks}
                min={0}
                max={1}
                onChange={(event, value) => sliderOnChange("tiles_auto_sort", value)}
              />
            </StyledPreferenceRow>
            <Divider />
            <StyledPreferenceRow>
              <Typography id="discrete-slider-restrict" gutterBottom>
                {t("gamePreferenceDialog.autoDraw")}
              </Typography>
              <Slider
                value={gamePreference.tile_auto_draw? gamePreference.tile_auto_draw : 0}
                valueLabelDisplay="auto"
                valueLabelFormat={booleanValueLabelFormat}
                step={1}
                marks={booleanMarks}
                min={0}
                max={1}
                onChange={(event, value) => sliderOnChange("tile_auto_draw", value)}
              />
            </StyledPreferenceRow>
            <Divider />
            <StyledPreferenceRow>
              <Typography id="discrete-slider-restrict" gutterBottom>
                {t("gamePreferenceDialog.beginnerMode")}
              </Typography>
              <Slider
                value={gamePreference.start_tile_manipulation? gamePreference.start_tile_manipulation : 0}
                valueLabelDisplay="auto"
                valueLabelFormat={booleanValueLabelFormat}
                step={1}
                marks={booleanMarks}
                min={0}
                max={1}
                onChange={(event, value) => sliderOnChange("start_tile_manipulation", value)}
              />
            </StyledPreferenceRow>
            <Divider />
            {/* <StyledPreferenceRow>
              <Typography id="discrete-slider-restrict" gutterBottom>
               新手模式
              </Typography>
              <Slider
                defaultValue={gamePreference.draw_tile_manipulation}
                valueLabelDisplay="auto"
                valueLabelFormat={booleanValueLabelFormat}
                step={1}
                marks={booleanMarks}
                min={0}
                max={1}
                onChange={(event, value) => sliderOnChange("draw_tile_manipulation", value)}
              />
            </StyledPreferenceRow> */}
            <Divider />
            <StyledPreferenceRow>
              <Typography id="discrete-slider-restrict" gutterBottom>
                {t("gamePreferenceDialog.pcPlayTime")}
              </Typography>
              <Slider
                value={gamePreference.discard_waiting_time? gamePreference.discard_waiting_time : 0}
                valueLabelDisplay="auto"
                step={2}
                marks={discardWaitingTimeMarks}
                min={3}
                max={11}
                onChange={(event, value) => sliderOnChange("discard_waiting_time", value)}
              />
            </StyledPreferenceRow>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                {t("butt.cancel")}
              </Button>
              <Button onClick={saveButtonClicked} color="primary" disabled={isLoading} variant="contained">
                {t("butt.save")}
              </Button>
            </DialogActions>
          </div>
        }
      </StyledDialogContent>
    </Dialog>
  )
}